import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { TranslationTag } from '@swf/core/types/i18n';
import { MultipleBetType } from '@swf/generated/types/api/sports';

import {
  TXTWCL_A_10_Fold_Accumulator_consists_ELL,
  TXTWCL_A_12_Fold_Accumulator_consists_ELL,
  TXTWCL_A_13_Fold_Accumulator_consists_ELL,
  TXTWCL_A_14_Fold_Accumulator_consists_ELL,
  TXTWCL_A_15_Fold_Accumulator_consists_ELL,
  TXTWCL_A_16_Fold_Accumulator_consists_ELL,
  TXTWCL_A_17_Fold_Accumulator_consists_ELL,
  TXTWCL_A_19_Fold_Accumulator_consists_ELL,
  TXTWCL_A_20_Fold_Accumulator_consists_ELL,
  TXTWCL_A_21_Fold_Accumulator_consists_ELL,
  TXTWCL_A_22_Fold_Accumulator_consists_ELL,
  TXTWCL_A_23_Fold_Accumulator_consists_ELL,
  TXTWCL_A_24_Fold_Accumulator_consists_ELL,
  TXTWCL_A_25_Fold_Accumulator_consists_ELL,
  TXTWCL_A_4_Fold_Accumulator_consists__ELL,
  TXTWCL_A_5_Fold_Accumulator_consists__ELL,
  TXTWCL_A_6_Fold_Accumulator_consists__ELL,
  TXTWCL_A_7_Fold_Accumulator_consists__ELL,
  TXTWCL_A_9_Fold_Accumulator_consists__ELL,
  TXTWCL_A_Canadian_Xalso_known_as_a_Su_ELL,
  TXTWCL_A_Double_consists_of_1_bet_inv_ELL,
  TXTWCL_A_Goliath_consists_of_247_bets_ELL,
  TXTWCL_A_Heinz_consists_of_57_bets_in_ELL,
  TXTWCL_A_Lucky_15_consists_of_15_bets_ELL,
  TXTWCL_A_Lucky_31_consists_of_31_bets_ELL,
  TXTWCL_A_Lucky_63_consists_of_63_bets_ELL,
  TXTWCL_A_Patent_consists_of_7_bets_in_ELL,
  TXTWCL_A_Super_Heinz_consists_of_120__ELL,
  TXTWCL_A_Treble_consists_of_1_bet_inv_ELL,
  TXTWCL_A_Trixie_consists_of_4_bets_in_ELL,
  TXTWCL_A_Yankee_consists_of_11_bets_i_ELL,
  TXTWCL_An_11_Fold_Accumulator_consist_ELL,
  TXTWCL_An_18_Fold_Accumulator_consist_ELL,
  TXTWCL_An_8_Fold_Accumulator_consists_ELL,
  TXTWCL_Bet_Builder_allows_you_to_comb_ELL
} from './MultiplesTooltipContent.messages.json';

interface Props {
  betType?: MultipleBetType;
  isSgm?: boolean;
}

const multipleTranslations: Record<MultipleBetType, TranslationTag> = {
  [MultipleBetType.DOUBLE]: TXTWCL_A_Double_consists_of_1_bet_inv_ELL,
  [MultipleBetType.TREBLE]: TXTWCL_A_Treble_consists_of_1_bet_inv_ELL,
  [MultipleBetType.FOURFOLD]: TXTWCL_A_4_Fold_Accumulator_consists__ELL,
  [MultipleBetType.FIVEFOLD]: TXTWCL_A_5_Fold_Accumulator_consists__ELL,
  [MultipleBetType.SIXFOLD]: TXTWCL_A_6_Fold_Accumulator_consists__ELL,
  [MultipleBetType.SEVENFOLD]: TXTWCL_A_7_Fold_Accumulator_consists__ELL,
  [MultipleBetType.EIGHTFOLD]: TXTWCL_An_8_Fold_Accumulator_consists_ELL,
  [MultipleBetType.NINEFOLD]: TXTWCL_A_9_Fold_Accumulator_consists__ELL,
  [MultipleBetType.TENFOLD]: TXTWCL_A_10_Fold_Accumulator_consists_ELL,
  [MultipleBetType.ELEVENFOLD]: TXTWCL_An_11_Fold_Accumulator_consist_ELL,
  [MultipleBetType.TWELVEFOLD]: TXTWCL_A_12_Fold_Accumulator_consists_ELL,
  [MultipleBetType.THIRTEENFOLD]: TXTWCL_A_13_Fold_Accumulator_consists_ELL,
  [MultipleBetType.FOURTEENFOLD]: TXTWCL_A_14_Fold_Accumulator_consists_ELL,
  [MultipleBetType.FIFTEENFOLD]: TXTWCL_A_15_Fold_Accumulator_consists_ELL,
  [MultipleBetType.SIXTEENFOLD]: TXTWCL_A_16_Fold_Accumulator_consists_ELL,
  [MultipleBetType.SEVENTEENFOLD]: TXTWCL_A_17_Fold_Accumulator_consists_ELL,
  [MultipleBetType.EIGHTEENFOLD]: TXTWCL_An_18_Fold_Accumulator_consist_ELL,
  [MultipleBetType.NINETEENFOLD]: TXTWCL_A_19_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYFOLD]: TXTWCL_A_20_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYONEFOLD]: TXTWCL_A_21_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYTWOFOLD]: TXTWCL_A_22_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYTHREEFOLD]: TXTWCL_A_23_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYFOURFOLD]: TXTWCL_A_24_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TWENTYFIVEFOLD]: TXTWCL_A_25_Fold_Accumulator_consists_ELL,
  [MultipleBetType.TRIXIE]: TXTWCL_A_Trixie_consists_of_4_bets_in_ELL,
  [MultipleBetType.PATENT]: TXTWCL_A_Patent_consists_of_7_bets_in_ELL,
  [MultipleBetType.YANKEE]: TXTWCL_A_Yankee_consists_of_11_bets_i_ELL,
  [MultipleBetType.CANADIAN]: TXTWCL_A_Canadian_Xalso_known_as_a_Su_ELL,
  [MultipleBetType.HEINZ]: TXTWCL_A_Heinz_consists_of_57_bets_in_ELL,
  [MultipleBetType.SUPER_HEINZ]: TXTWCL_A_Super_Heinz_consists_of_120__ELL,
  [MultipleBetType.GOLIATH]: TXTWCL_A_Goliath_consists_of_247_bets_ELL,
  [MultipleBetType.LUCKY15]: TXTWCL_A_Lucky_15_consists_of_15_bets_ELL,
  [MultipleBetType.LUCKY31]: TXTWCL_A_Lucky_31_consists_of_31_bets_ELL,
  [MultipleBetType.LUCKY63]: TXTWCL_A_Lucky_63_consists_of_63_bets_ELL
};

const MultiplesTooltipContent: React.FC<Props> = ({
  betType = MultipleBetType.DOUBLE,
  isSgm = false
}) => {
  if (isSgm) {
    return <Translation {...TXTWCL_Bet_Builder_allows_you_to_comb_ELL} />;
  }

  return <Translation {...multipleTranslations[betType]} />;
};

export default MultiplesTooltipContent;
